import React, { Fragment, useState, useEffect } from 'react';
import * as Yup from 'yup';
import numeral from 'numeral';
import NumberFormat from 'react-number-format';

import PerfectScrollbar from 'react-perfect-scrollbar';

import agm from '../../services/agm';
import Alerts from '../../utils/alerts';
import Find from './Find';

import { makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';

import {
    KeyboardDatePicker
} from '@material-ui/pickers';

import {
    Tooltip,
    Avatar,
    Button,
    Box,
    colors,
    Icon,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableContainer,
    Typography,
    Grid,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    TextField,
    Card,
    CardContent,
    IconButton,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: 680,
        backgroundColor: theme.palette.background.paper,
    },
    avatar: {
        marginRight: theme.spacing(1),
        backgroundColor: colors.grey[200]
    },
    container: {
        maxHeight: 340,
    },
    input: {
        color: colors.cyan['A700']
    },
    inputErro: {
        color: colors.red[900]
    },
    products: {
        padding: 0
    }
}));

import { IoMdCart } from "react-icons/io";
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import Add from '@material-ui/icons/AddCircleOutline';

const Inventory = ({ item, open, closeEdition, updateValues, dependencies }) => {

    const classes = useStyles();

    const [openAlert, setOpenAlert] = useState(false);
    const [message, setMessage] = useState({});

    const [openFind, setOpenFind] = useState(false);

    const closeAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const closeFind = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenFind(false);
    };

    const getRandomId = () => {
        var min = Math.ceil(9900);
        var max = Math.floor(10000);
        return parseInt(Math.floor(Math.random() * (max - min + 1)) + min) * -1;
    };

    const selectProduct = (values, produto) => {
        values.idProduto = produto.id;
        values.qtdProduto = 1;
        values.codigoProduto = produto.codigo;
        values.nomeProduto = produto.nome;
        values.lpuProduto = produto.lpu;
        values.custoProduto = numeral((produto.custo) ? produto.custo : 0).format('0.00');
        values.bdiProduto = numeral((produto.bdi) ? produto.bdi : 0).format('0.00');
        values.valorProduto = numeral((produto.valor) ? produto.valor : 0).format('0.00');
        values.instalacaoProduto = numeral((produto.instalacao) ? produto.instalacao : 0).format('0.00');
        values.produto = produto;
        closeFind();
    }

    const handleAddItem = async (values) => {
        if (values.idProduto) {
            dependencies.items.push({
                id: getRandomId(),
                qtd: values.qtdProduto,
                custo: values.custoProduto,
                bdi: values.bdiProduto,
                valor: values.valorProduto,
                instalacao: values.instalacaoProduto,
                produto: values.produto,
                aberto: 1
            });

            values.valorMaoObra = 0.0;
            values.valorMaterial = 0.0;
            for (let index = 0; index < dependencies.items.length; index++) {
                var prod = dependencies.items[index];
                values.valorMaoObra = (parseFloat(values.valorMaoObra) + (parseFloat(parseFloat(prod.instalacao) * parseFloat(prod.qtd))));
                values.valorMaterial = (parseFloat(values.valorMaterial) + (parseFloat(parseFloat(prod.valor) * parseFloat(prod.qtd))));
            }
            values.total = (parseFloat(values.valorMaoObra) + parseFloat(values.valorMaterial) - parseFloat(values.valorDesconto));
            values.idProduto = ''
            values.qtdProduto = '';
            values.codigoProduto = '';
            values.nomeProduto = '';
            values.lpuProduto = '';
            values.custoProduto = '';
            values.bdiProduto = '';
            values.valorProduto = '';
            values.instalacaoProduto = '';
            values.produto = null;
            document.getElementById('codigoProduto').focus();
        } else {
            setOpenFind(true);
        }
    }

    const handleRemoveItem = async (item, values) => {
        for (let index = 0; index < dependencies.items.length; index++) {
            var prod = dependencies.items[index];
            if (prod.id == item.id) {
                dependencies.items.splice(index, 1);
                dependencies.removes.push(prod);
                break;
            }
        }
        values.valorMaoObra = 0.0;
        values.valorMaterial = 0.0;
        for (let index = 0; index < dependencies.items.length; index++) {
            prod = dependencies.items[index];
            values.valorMaoObra = (parseFloat(values.valorMaoObra) + (parseFloat(parseFloat(prod.instalacao) * parseFloat(prod.qtd))));
            values.valorMaterial = (parseFloat(values.valorMaterial) + (parseFloat(parseFloat(prod.valor) * parseFloat(prod.qtd))));
        }
        values.total = (parseFloat(values.valorMaoObra) + parseFloat(values.valorMaterial) - parseFloat(values.valorDesconto));
        document.getElementById('codigoProduto').focus();
        document.getElementById('nomeProduto').focus();
        await document.getElementById('codigoProduto').focus();
    }

    const requestProductCode = async (value, values) => {
        if (value != '') {
            await agm.get('/orcamentos/produtos/' + value, {}, {}).then((response) => {
                if (!response.data.error) {
                    var list = response.data;
                    if (list.length > 0) {
                        var produto = list[0];
                        values.idProduto = produto.id;
                        values.qtdProduto = 1;
                        values.codigoProduto = produto.codigo;
                        values.nomeProduto = produto.nome;
                        values.lpuProduto = produto.lpu;
                        values.custoProduto = numeral((produto.custo) ? produto.custo : 0).format('0.00');
                        values.bdiProduto = numeral((produto.bdi) ? produto.bdi : 0).format('0.00');
                        values.valorProduto = numeral((produto.valor) ? produto.valor : 0).format('0.00');
                        values.instalacaoProduto = numeral((produto.instalacao) ? produto.instalacao : 0).format('0.00');
                        values.produto = produto;
                    }
                } else {
                    values.idProduto = ''
                    values.qtdProduto = '';
                    values.codigoProduto = '';
                    values.nomeProduto = '';
                    values.lpuProduto = '';
                    values.custoProduto = '';
                    values.bdiProduto = '';
                    values.valorProduto = '';
                    values.instalacaoProduto = '';
                    values.produto = null;
                    setMessage(response.data);
                    setOpenAlert(true);
                }
            }).catch((error) => {
                console.error(error);
            })
        }
    }

    useEffect(() => {
        return
    }, []);

    return (
        <Fragment>

            <Alerts message={message}
                open={openAlert}
                closeAlert={closeAlert} />

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="xl" fullWidth>
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Entrada no Estoque
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                ordem: Yup.string().required('Ocorrência é obrigatória'),
                                dataEmissao: Yup.string().required('Ocorrência é obrigatória'),
                            })
                        }
                        onSubmit={(values, formik) => {
                            updateValues(values, dependencies.items, dependencies.removes);
                            formik.setSubmitting(false);
                        }}

                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (

                            <form onSubmit={handleSubmit}>

                                <Find open={openFind}
                                    closeFind={closeFind}
                                    selectProduct={selectProduct}
                                    values={values} />

                                <Box className={classes.root} >

                                    <Grid
                                        container
                                        spacing={1}
                                        xs="auto"
                                    >
                                        <Grid
                                            item
                                            md={1}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.ordem && errors.ordem)}
                                                fullWidth
                                                required
                                                label="Número"
                                                margin="normal"
                                                name="ordem"
                                                id="ordem"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={numeral(values.ordem).format('000000')}
                                                variant="outlined"
                                                inputProps={
                                                    { readOnly: true, }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <KeyboardDatePicker
                                                fullWidth
                                                required
                                                cancelLabel="Cancelar"
                                                margin="normal"
                                                inputVariant="outlined"
                                                id="dataEmissao"
                                                name="dataEmissao"
                                                label="Data do Lançamento"
                                                format="DD/MM/YYYY"
                                                value={values.dataEmissao}
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("dataEmissao", value)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={1}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.numero && errors.numero)}
                                                fullWidth
                                                label="Nota"
                                                margin="normal"
                                                name="numero"
                                                id="numero"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.numero}
                                                variant="outlined"
                                                inputProps={
                                                    { readOnly: false, }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <NumberFormat
                                                fullWidth
                                                label="Total Líquido da Nota"
                                                margin="normal"
                                                id="valorLiquido"
                                                name="valorLiquido"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.valorLiquido}
                                                variant="outlined"
                                                decimalScale="2"
                                                fixedDecimalScale="true"
                                                customInput={TextField}
                                                inputProps={
                                                    {
                                                        readOnly: false,
                                                        className: classes.input
                                                    }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <NumberFormat
                                                fullWidth
                                                label="Total de Impostos"
                                                margin="normal"
                                                id="valorImposto"
                                                name="valorImposto"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.valorImposto}
                                                variant="outlined"
                                                decimalScale="2"
                                                fixedDecimalScale="true"
                                                customInput={TextField}
                                                inputProps={
                                                    {
                                                        readOnly: false,
                                                        className: classes.input
                                                    }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <NumberFormat
                                                fullWidth
                                                label="Valor de Ajuste"
                                                margin="normal"
                                                id="valorAjuste"
                                                name="valorAjuste"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.valorAjuste}
                                                variant="outlined"
                                                decimalScale="2"
                                                fixedDecimalScale="true"
                                                customInput={TextField}
                                                inputProps={
                                                    {
                                                        readOnly: false,
                                                        className: classes.input
                                                    }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <NumberFormat
                                                fullWidth
                                                label="Total da Nota"
                                                margin="normal"
                                                id="total"
                                                name="total"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={parseFloat(values.valorLiquido) + parseFloat(values.valorImposto) + parseFloat(values.valorAjuste)}
                                                variant="outlined"
                                                decimalScale="2"
                                                fixedDecimalScale="true"
                                                customInput={TextField}
                                                inputProps={
                                                    {
                                                        readOnly: true,
                                                        className: classes.input
                                                    }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={12}
                                            xs={12}
                                        >
                                            <TextField
                                                error={Boolean(touched.fornecedor && errors.fornecedor)}
                                                fullWidth
                                                label="Descrição (Campo Livre)"
                                                rows={1}
                                                length={512}
                                                multiline
                                                margin="none"
                                                id="fornecedor"
                                                name="fornecedor"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.fornecedor}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>

                                            <Card className={classes.products}>
                                                <CardContent>

                                                    <Grid container
                                                        direction="row"
                                                        justify="flex-start"
                                                        alignItems="center"
                                                        spacing={1}  >

                                                        <Grid
                                                            item
                                                            md={1}
                                                            xs={12}>

                                                            <TextField
                                                                fullWidth
                                                                label="Código"
                                                                margin="normal"
                                                                name="codigoProduto"
                                                                id="codigoProduto"
                                                                onBlur={e => {
                                                                    handleBlur(e);
                                                                    requestProductCode(e.currentTarget.value, values);
                                                                }}
                                                                onChange={handleChange}
                                                                value={values.codigoProduto}
                                                                variant="outlined"
                                                                InputLabelProps={{ shrink: true }}
                                                            />

                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md={4}
                                                            xs={12}>

                                                            <TextField
                                                                fullWidth
                                                                label="Nome"
                                                                margin="normal"
                                                                name="nomeProduto"
                                                                id="nomeProduto"
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                                value={values.nomeProduto}
                                                                variant="outlined"
                                                                InputLabelProps={{ shrink: true }}
                                                            />
                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md={1}
                                                            xs={12}>
                                                            <NumberFormat
                                                                fullWidth
                                                                label="Estoque"
                                                                margin="normal"
                                                                name="qtdProduto"
                                                                id="qtdProduto"
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                                value={values.qtdProduto}
                                                                variant="outlined"
                                                                decimalScale="2"
                                                                fixedDecimalScale="true"
                                                                customInput={TextField}
                                                                InputLabelProps={{ shrink: true }}
                                                            />

                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md={1}
                                                            xs={12}>
                                                            <NumberFormat
                                                                fullWidth
                                                                label="Valor Custo"
                                                                margin="normal"
                                                                name="custoProduto"
                                                                id="custoProduto"
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                                value={values.custoProduto}
                                                                variant="outlined"
                                                                decimalScale="2"
                                                                fixedDecimalScale="true"
                                                                customInput={TextField}
                                                                InputLabelProps={{ shrink: true }}
                                                            />

                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md={1}
                                                            xs={12}>
                                                            <NumberFormat
                                                                fullWidth
                                                                label="BDI"
                                                                margin="normal"
                                                                name="bdiProduto"
                                                                id="bdiProduto"
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                                value={values.bdiProduto}
                                                                variant="outlined"
                                                                decimalScale="2"
                                                                fixedDecimalScale="true"
                                                                customInput={TextField}
                                                                InputLabelProps={{ shrink: true }}
                                                            />

                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md={1}
                                                            xs={12}>
                                                            <NumberFormat
                                                                fullWidth
                                                                label="Valor Material"
                                                                margin="normal"
                                                                name="valorProduto"
                                                                id="valorProduto"
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                                value={values.valorProduto}
                                                                variant="outlined"
                                                                decimalScale="2"
                                                                fixedDecimalScale="true"
                                                                customInput={TextField}
                                                                InputLabelProps={{ shrink: true }}
                                                            />

                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md={1}
                                                            xs={12}>
                                                            <NumberFormat
                                                                fullWidth
                                                                label="Valor Mão Obra"
                                                                margin="normal"
                                                                name="instalacaoProduto"
                                                                id="instalacaoProduto"
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                                value={values.instalacaoProduto}
                                                                variant="outlined"
                                                                decimalScale="2"
                                                                fixedDecimalScale="true"
                                                                customInput={TextField}
                                                                InputLabelProps={{ shrink: true }}
                                                            />

                                                        </Grid>

                                                        <Grid item
                                                            md={1}
                                                            xs={12}>

                                                            <Button
                                                                color="secondary"
                                                                size="medium"
                                                                variant="contained"
                                                                startIcon={<Add />}
                                                                onBlur={handleBlur}
                                                                onClick={() => { handleAddItem(values) }}>
                                                                Adicionar
                                                            </Button>
                                                        </Grid>
                                                    </Grid>

                                                    <br></br>
                                                    <Grid container
                                                        direction="row"
                                                        justify="flex-start"
                                                        alignItems="center"
                                                        spacing={1}  >

                                                        <Grid item
                                                            md={12}
                                                            xs={12}>

                                                            <TableContainer component={PerfectScrollbar} className={classes.container}>

                                                                <Table stickyHeader size="small" aria-label="a dense table" >
                                                                    <TableHead>

                                                                        <TableRow>

                                                                            <TableCell>
                                                                                Código
                                                                            </TableCell>

                                                                            <TableCell>
                                                                                Nome
                                                                            </TableCell>

                                                                            <TableCell>
                                                                                LPU
                                                                            </TableCell>

                                                                            <TableCell>
                                                                                Estoque
                                                                            </TableCell>

                                                                            <TableCell>
                                                                                Unidade
                                                                            </TableCell>

                                                                            <TableCell align="right">
                                                                                Valor Custo
                                                                            </TableCell>

                                                                            <TableCell align="right">
                                                                                BDI
                                                                            </TableCell>

                                                                            <TableCell align="right">
                                                                                Valor Material
                                                                            </TableCell>

                                                                            <TableCell align="right">
                                                                                Valor Mão Obra
                                                                            </TableCell>

                                                                            <TableCell>
                                                                                &nbsp;
                                                                            </TableCell>

                                                                        </TableRow>

                                                                    </TableHead>

                                                                    <TableBody>
                                                                        {dependencies.items.map((itemorc) => (
                                                                            <TableRow
                                                                                hover
                                                                                key={itemorc.id}
                                                                            >
                                                                                <TableCell width={10}>
                                                                                    <Box
                                                                                        alignItems="center"
                                                                                        display="flex"
                                                                                    >
                                                                                        <Avatar
                                                                                            className={classes.avatar}
                                                                                        >
                                                                                            {<Icon component={IoMdCart} style={{ color: colors.cyan[500] }} ></Icon>}
                                                                                        </Avatar>
                                                                                        {numeral(itemorc.produto.codigo).format('0000')}
                                                                                    </Box>
                                                                                </TableCell>

                                                                                <TableCell>
                                                                                    {itemorc.produto.nome}
                                                                                </TableCell>

                                                                                <TableCell >
                                                                                    {itemorc.produto.lpu.nome} &nbsp;
                                                                                    {itemorc.produto.codigoLpu}
                                                                                </TableCell>

                                                                                <TableCell align="center">
                                                                                    {itemorc.qtd}
                                                                                </TableCell>

                                                                                <TableCell align="center">
                                                                                    {(itemorc.produto.unidadeProduto) ? itemorc.produto.unidadeProduto.nome : "??"}
                                                                                </TableCell>

                                                                                <TableCell align="right">
                                                                                    {numeral(itemorc.custo).format('0.00')}
                                                                                </TableCell>

                                                                                <TableCell align="right">
                                                                                    {numeral(itemorc.bdi).format('0.00')}
                                                                                </TableCell>

                                                                                <TableCell align="right">
                                                                                    {numeral(itemorc.valor).format('0.00')}
                                                                                </TableCell>

                                                                                <TableCell align="right">
                                                                                    {numeral(itemorc.instalacao).format('0.00')}
                                                                                </TableCell>
                                                                                <TableCell >
                                                                                    <Tooltip title="Excluir Produto">
                                                                                        <IconButton
                                                                                            disabled={!itemorc.aberto}
                                                                                            color="secondary"
                                                                                            className={classes.btntreatment}
                                                                                            children={<DeleteRoundedIcon />}
                                                                                            size="medium"
                                                                                            onClick={() => { handleRemoveItem(itemorc, values) }}>
                                                                                        </IconButton>
                                                                                    </Tooltip>
                                                                                </TableCell>

                                                                            </TableRow>
                                                                        ))
                                                                        }

                                                                        {(dependencies.items.length == 0) ? (
                                                                            <TableRow  >
                                                                                <TableCell colSpan={10} align="center" >
                                                                                    Nenhum Produto Foi Adicionado.
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ) : ('')}


                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer>

                                                        </Grid>

                                                    </Grid>

                                                </CardContent>
                                            </Card>
                                        </Grid>

                                    </Grid>

                                </Box>

                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>

                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>

                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeEdition() }}>
                                                Fechar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Inventory;